<template>
  <ls-table-layout>
    <template #tabs>
      <ls-button-group
        ref="statesTabsRef"
        :current="activeStateKey"
        :button-item="STATUS_CODE_TAB_V_LIST"
        type="tabs"
        @select="onChangeState"
      >
      </ls-button-group>
    </template>
    <template #search>
      <SearchForm ref="searchFormRef" @search="onSearch" :activeStateKey="activeStateKey" @toggleAdvanced="onToggleAdvanced" />
    </template>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button key="mes:mesDiscreteJobsCc:add" @click="$refs.addModalRef.show()" type="primary" v-hasPermi="['mes:mesDiscreteJobsCc:add']">新建</a-button>
      <span v-if="showCancelBtnIs">
        <a-button
          key="mes:mesDiscreteJobsCc:cancel"
          @click="handleCallOff"
          :loading="btnLoading"
          type="danger"
          v-hasPermi="['mes:mesDiscreteJobsCc:cancel']"
        >取消</a-button>
      </span>
      <span v-if="STATUS_CODE.RECEIVED.lookupCode === activeStateKey">
        <a-button
          key="mes:mesDiscreteJobsCc:batchClose"
          @click="handleClose"
          :loading="btnLoading"
          type="danger"
          v-hasPermi="['mes:mesDiscreteJobsCc:batchClose']"
        >关闭</a-button>
      </span>
      <span v-if="showScheduleBtnIs">
        <a-button
          key="mes:mesDiscreteJobsCc:confirmProductionScheduling"
          v-hasPermi="['mes:mesDiscreteJobsCc:confirmProductionScheduling', 'mes:mesDiscreteJobsCc:confirmPublish']"
          @click="handleShowScheduleModal"
          :loading="btnLoading"
        >排产</a-button>
      </span>
      <span v-if="STATUS_CODE.PLANNED_PRODUCT.lookupCode === activeStateKey">
        <a-button
          key="mes:mesDiscreteJobsCc:publish"
          v-hasPermi="['mes:mesDiscreteJobsCc:publish']"
          @click="handlePublish"
          :loading="btnLoading"
        >发布</a-button>
      </span>
      <span v-if="showScheduleBtnIs">
        <a-button
          key="mes:mesDiscreteJobsCc:splitOrderConfirmPc"
          v-hasPermi="['mes:mesDiscreteJobsCc:splitOrderConfirmPc', 'mes:mesDiscreteJobsCc:splitOrderConfirmPublish']"
          @click="handleSplitOrder"
          :loading="btnLoading"
          type="danger"
        >拆单排产</a-button>
      </span>
      <span v-if="STATUS_CODE.PUBLISHED.lookupCode === activeStateKey">
        <a-button
          key="mes:mesDiscreteJobsCc:dispatch"
          v-hasPermi="['mes:mesDiscreteJobsCc:dispatch']"
          @click="handleDispatch"
          :loading="btnLoading"
        >派工</a-button>
        <a-button
          key="mes:mesDiscreteJobsCc:revokePublish"
          v-hasPermi="['mes:mesDiscreteJobsCc:revokePublish']"
          @click="handleCancelPublish"
          :loading="btnLoading"
          type="danger"
        >撤销发布</a-button>
      </span>
      <span v-if="STATUS_CODE.DISPATCHED.lookupCode === activeStateKey">
        <a-button
          key="mes:mesDiscreteJobsCc:revokeDispatch"
          v-hasPermi="['mes:mesDiscreteJobsCc:revokeDispatch']"
          @click="handleCancelDispatch"
          :loading="btnLoading"
        >撤销派工</a-button>
      </span>
      <a-button
        key="addRequisition"
        v-hasPermi="['mes:mesDiscreteJobsCc:addRequisition', 'mes:mesDiscreteJobsCc:addRequisitionDispatch']"
        @click="onShowAddMaterialModal"
        :loading="btnLoading"
      >新增领料单</a-button>
      <a-button
        key="ccDiscreteJobsDisassembly"
        v-hasPermi="['mes:mesDiscreteJobs:ccDiscreteJobsDisassembly']"
        @click="onShowDismantleModal"
        :loading="btnLoading"
      >拆解</a-button>
      <a-button @click="handleUpdateTime" :loading="btnLoading" type="primary" v-hasPermi="['mes:mesDiscreteJobsCc:linkageSuperTime']">联动上级工单时间</a-button>
      <span v-if="activeTableType === TICKET_TABLE_TYPE.ticketInfo.value">
        <a-button key="export1" :loading="exportLoading" @click="handleExport" v-hasPermi="['mes:mesDiscreteJobsCc:export']">导出</a-button>
      </span>
      <span v-else-if="activeTableType === TICKET_TABLE_TYPE.materialInfo.value">
        <a-button key="export2" :loading="exportLoading" @click="handleExport" v-hasPermi="['mes:mesRequirementOperationsCc:export']">导出</a-button>
      </span>
      <span v-else-if="activeTableType === TICKET_TABLE_TYPE.relateBill.value">
        <a-button key="export3" :loading="exportLoading" @click="handleExport" v-hasPermi="['mes:mesDiscreteJobsCc:exportAssociatedWorkOrder']">导出</a-button>
      </span>
      <a-button :loading="btnLoading" type="primary" @click="handleMaterialChange" v-hasPermi="['mes:mesDiscreteJobsCc:getByRequirementIds']">发起物料变更</a-button>
      <!--      <a-button @click="importExcelHandleOpen" v-hasPermi="['bom:bomSalaryUnitPriceCc:import']">导入</a-button>-->
    </div>
    <template v-slot:table>
      <a-tabs v-model="activeTableType" type="card" @change="onTableTypeChange">
        <a-tab-pane v-for="item in tableTypeList" :key="item.value" :tab="item.label"></a-tab-pane>
      </a-tabs>
      <div class="page-header-content">
        <ls-api-table
          ref="baseTable"
          :columns="dyCols"
          :table-props="tableProps"
          :scroll="{ fixScreen: true, x: scrollX }"
          :custom-selection="{ stickyFixed: true }"
          :selectedRows.sync="selectedRows"
          @selectedRowChange="selectedRowChange"
          :multi-select="true"
        >
          <template #roItemCodeTitle>
            <span>组件物料</span>
            <!---<span v-hasPermi="['mes:mesRequirementOperationsCc:edit']">
              <a-icon
                v-if="TICKET_TABLE_TYPE.materialInfo.value === activeTableType"
                class="action-icon"
                @click.stop="onMaterialEdit('roItemCode')"
                type="edit"
                title="编辑"
              />
            </span>-->
          </template>
          <template #quantityPerAssemblyTitle>
            <span>用量</span>
            <!---<span v-hasPermi="['mes:mesRequirementOperationsCc:edit']">
              <a-icon
                v-if="TICKET_TABLE_TYPE.materialInfo.value === activeTableType"
                class="action-icon"
                @click.stop="onMaterialEdit('quantityPerAssembly')"
                type="edit"
                title="编辑"
              />
            </span>-->
          </template>
          <template #scheduledStartDateTitle>
            <span>计划开始时间</span>
            <span v-hasPermi="['mes:mesDiscreteJobsCc:batchEdit']">
              <a-icon v-if="TICKET_TABLE_TYPE.ticketInfo.value === activeTableType" class="action-icon" @click.stop="onBatchEdit('scheduledStartDate')" type="edit" title="编辑"/>
            </span>
          </template>
          <template #scheduledCompletionDateTitle>
            <span>计划完成时间</span>
            <span v-hasPermi="['mes:mesDiscreteJobsCc:batchEdit']">
              <a-icon v-if="TICKET_TABLE_TYPE.ticketInfo.value === activeTableType" class="action-icon" @click.stop="onBatchEdit('scheduledCompletionDate')" type="edit" title="编辑"/>
            </span>
          </template>
          <template #workCenterNameTitle>
            <span>工作中心</span>
            <span v-hasPermi="['mes:mesDiscreteJobsCc:batchEdit']">
              <a-icon v-if="TICKET_TABLE_TYPE.ticketInfo.value === activeTableType" class="action-icon" @click.stop="onBatchEdit('workCenterCode')" type="edit" title="编辑"/>
            </span>
          </template>
          <template #teamGroupNameTitle>
            <span>班组</span>
            <span v-hasPermi="['mes:mesDiscreteJobsCc:batchEdit']">
              <a-icon v-if="TICKET_TABLE_TYPE.ticketInfo.value === activeTableType" class="action-icon" @click.stop="onBatchEdit('teamGroupCode')" type="edit" title="编辑"/>
            </span>
          </template>
          <template #scheduledStartDate="{ record }">
            <a-date-picker
              class="select-width-130"
              v-if="record.editIs"
              v-model="record.scheduledStartDate"
              format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              :show-time="{ defaultValue: $moment('00:00:00', 'HH:mm:ss') }"
              allowClear
              style="min-width: 170px;width: 170px"
            />
            <template v-else>{{ formatDate(record.scheduledStartDate) }}</template>
          </template>
          <template #scheduledCompletionDate="{ record }">
            <a-date-picker
              v-if="record.editIs"
              v-model="record.scheduledCompletionDate"
              format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              :show-time="{ defaultValue: $moment('00:00:00', 'HH:mm:ss') }"
              allowClear
              style="min-width: 170px;width: 170px"
            />
            <template v-else>{{ formatDate(record.scheduledCompletionDate) }}</template>
          </template>
          <template #workCenterName="{ record }">
            <global-select
              v-if="record.editIs"
              class="select-width-130"
              v-model="record.workCenterCode"
              selectType="selectAssembleSearch"
              assembleLabel
              searchParam="centerName"
              requestApi="/bom/workCenter/list"
              :selectItem="{ value: 'centerCode', label: 'centerName' }"
              :setParams="{ workshopCode: record.workCode }"
            />
            <template v-else>{{ record.workCenterName }}</template>
          </template>
          <template #formatDate="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template #remarks="{ text, record }">
            <a-input v-if="record.editIs" v-model="record.remarks" :maxLength="100" />
            <a-tooltip v-else :title="text"><div class="text-3-ellipsis">{{ text }}</div></a-tooltip>
          </template>
          <template #YES_OR_NOT="{ text }">
            {{ YES_OR_NOT[text] }}
          </template>
          <template #componentItemCodeList="{ text }">
            <a-tooltip :title="text"><div class="text-3-ellipsis">{{ text && text.toString() }}</div></a-tooltip>
          </template>
          <template #textEllipsis="{ text }">
            <a-tooltip :title="text"><div class="text-3-ellipsis">{{ text }}</div></a-tooltip>
          </template>
          <template #operation="{ record }">
            <div v-hasPermi="['mes:mesDiscreteJobsCc:edit']">
              <a-button
                v-if="!record.editIs"
                type="link"
                class="link-btn"
                @click="() => onEdit(record, 1)"
              >编辑</a-button>
              <template v-else>
                <a-button
                  type="link"
                  class="link-btn"
                  :loading="record.loading"
                  @click="() => onSave(record)"
                >保存</a-button>
                <a-button
                  type="link"
                  class="link-btn"
                  :loading="record.loading"
                  @click="() => onEdit(record, 0)"
                >取消</a-button>
              </template>
              <a-button type="link" class="link-btn" @click="handleLog(record)">日志</a-button>
            </div>
          </template>
        </ls-api-table>
      </div>
      <AddModal ref="addModalRef" :mainBtnLoading="btnLoading" @successCall="refreshList" />
      <ImportExcel
        ref="importExcelRef"
        v-bind="importData"
        @refresh="refreshList"
      />
      <DownloadModal :apiFun="exportApi" ref="download" />
      <OperationLogModel ref="operationLogModelRef" :logLoading="logLoading" :logList="logList" @closeLog="closeLogFun" />
      <BatchEditModal ref="BatchEditModalRef" @click="refreshList" />
      <ScheduleModal ref="scheduleModalRef" :mainBtnLoading.sync="btnLoading" @successCall="refreshList" />
      <SpitOrderModal ref="splitOrderModalRef" :mainBtnLoading.sync="btnLoading" @successCall="refreshList" />
      <AddMaterialModal ref="addMaterialModalRef" :mainBtnLoading.sync="btnLoading" @successCall="refreshList" />
      <DismantleModal ref="dismantleModalRef" :mainBtnLoading.sync="btnLoading" @successCall="refreshList" />
      <UpdateMaterialModal ref="updateMaterialModalRef" @handle-success="refreshList" />
      <CancelModal ref="cancelModalRef" :mainBtnLoading.sync="btnLoading" @successCall="refreshList" />
      <MaterialChangeModal
        v-if="modalShow.materialChangeModal"
        ref="materialChangeModalRef"
        @successCall="materialChangeSuccess" />
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import moment from 'moment'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import SearchForm from './components/search-form.vue'
import AddModal from './components/add-modal.vue'
import ImportExcel from "@/components/ImportExcel/importExcel"
import BatchEditModal from './components/batch-edit-modal.vue'
import { formatDate, STATUS_CODE_TAB_V, TICKET_INFO_COL, TICKET_MATERIAL_COL, TICKET_TABLE_TYPE, STATUS_CODE, YES_OR_NOT } from './common'
import deepClone from 'lodash/cloneDeep'
import ScheduleModal from './components/schedule-modal.vue'
import {
  apiExportMesDiscreteJobsCc,
  apiExportRequirementOperationsCc,
  apiExportAssociatedWorkOrder,
  getMesDiscreteJobsCcLogApi,
  listMesDiscreteJobsCc,
  updateMesDiscreteJobsCc,
  apiCloseMesDiscreteJobsCcLog,
  apiPublishMesDiscreteJobsCcBill,
  apiDispatchMesDiscreteJobsCcBill,
  apiRevokeDispatchMesDiscreteJobsCcBill,
  apiRevokePublishMesDiscreteJobsCcBill, apiAssociatedWorkOrderList, apiRequirementOperationsCcList,
  apiLinkageSuperTimeCc
} from '@/api/mes/workOrderManage/ticketsManageCc'
import OperationLogModel from '@/components/operation-log/operation-log-model.vue'
import SpitOrderModal from './components/split-order-modal.vue'
import AddMaterialModal from '@/views/mes/workOrderManage/ticketsManageCc/components/add-material-modal.vue'
import DismantleModal from '@/views/mes/workOrderManage/ticketsManageCc/components/dismantle-modal.vue'
import UpdateMaterialModal from '@/views/mes/workOrderManage/ticketsManageCc/components/update-material-modal.vue'
import CancelModal from '@/views/mes/workOrderManage/ticketsManageCc/components/cancel-modal.vue'
import MaterialChangeModal from '@/views/mes/workOrderManage/ticketsManageCc/components/material-change-modal.vue'
export default {
  name: 'TicketsManageCc',
  components: {
    BatchEditModal,
    OperationLogModel,
    AddModal,
    DownloadModal,
    SearchForm,
    ImportExcel,
    ScheduleModal,
    SpitOrderModal,
    AddMaterialModal,
    DismantleModal,
    UpdateMaterialModal,
    MaterialChangeModal,
    CancelModal
  },
  data() {
    return {
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      activeStateKey: STATUS_CODE_TAB_V.ALL.lookupCode,
      activeTableType: TICKET_TABLE_TYPE.ticketInfo.value,
      btnLoading: false,
      exportLoading: false,
      logLoading: false,
      logList: [],
      operationTypeList: [], // 工序类型
      importData: {
        // 用户导入参数
        uploadParams: {
          url: process.env.VUE_APP_API_BASE_URL + '/mes/mesDiscreteJobsCc/import' // 上传的地址
        },
        // 导入模板下载参数
        downloadParams: {
          method: 'post',
          url: 'mes/mesDiscreteJobsCc/export',
          name: `裁床工单管理导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
        }
      },
      modalShow: {
        materialChangeModal: false
      },
      // 表格字段
      dyCols: TICKET_INFO_COL
    }
  },
  computed: {
    scrollX() {
      return this.dyCols.reduce((acc, cur) => {
        return acc + (cur.width || 120)
      }, 200)
    },
    YES_OR_NOT() {
      return YES_OR_NOT;
    },
    STATUS_CODE() {
      return STATUS_CODE;
    },
    // 展示排产/排产按钮
    showScheduleBtnIs() {
      return [
        STATUS_CODE.CREATE.lookupCode,
        STATUS_CODE.PLANNED_PRODUCT.lookupCode
      ].includes(this.activeStateKey)
    },
    // 展示取消按钮
    showCancelBtnIs() {
      return [
        STATUS_CODE.CREATE.lookupCode,
        STATUS_CODE.PLANNED_PRODUCT.lookupCode,
        STATUS_CODE.PUBLISHED.lookupCode,
        STATUS_CODE.DISPATCHED.lookupCode
      ].includes(this.activeStateKey)
    },
    tableProps() {
      const requestApi = {
        [TICKET_TABLE_TYPE.ticketInfo.value]: generateLsTableResData(listMesDiscreteJobsCc),
        [TICKET_TABLE_TYPE.materialInfo.value]: generateLsTableResData(apiRequirementOperationsCcList),
        [TICKET_TABLE_TYPE.relateBill.value]: generateLsTableResData(apiAssociatedWorkOrderList)
      }[this.activeTableType]
      return {
        requestApi,
        pageCurrent: false
      }
    },
    STATUS_CODE_TAB_V_LIST() {
      return Object.values(STATUS_CODE_TAB_V).map(item => ({
        id: item.lookupCode, name: item.lookupValue
      }));
    },
    tableTypeList() {
      return Object.values(TICKET_TABLE_TYPE);
    },
    TICKET_TABLE_TYPE() {
      return TICKET_TABLE_TYPE;
    },
    canEditIs() {
      return (record) => {
        return [STATUS_CODE.PLANNED_PRODUCT.lookupCode, STATUS_CODE.CREATE.lookupCode].includes(record.status)
      }
    },
    exportApi() {
      return {
        [TICKET_TABLE_TYPE.ticketInfo.value]: apiExportMesDiscreteJobsCc,
        [TICKET_TABLE_TYPE.materialInfo.value]: apiExportRequirementOperationsCc,
        [TICKET_TABLE_TYPE.relateBill.value]: apiExportAssociatedWorkOrder
      }[this.activeTableType]
    }
  },
  async mounted() {
    this.modalShow.materialChangeModal = false;
    this.$refs.searchFormRef.getCategoryIdList();
  },
  methods: {
    formatDate,
    handleUpdateTime() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请至少勾选一条单据进行操作")
      }
      this.btnLoading = true;
      apiLinkageSuperTimeCc(this.selectedRows.map(item => item.id)).then(res => {
        if (res.code === 200) {
          this.$message.success('操作成功!')
          this.refreshList();
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.btnLoading = false;
      })
    },
    // 发起变更
    handleMaterialChange() {
      if(this.activeTableType !== TICKET_TABLE_TYPE.materialInfo.value) {
        return this.$message.warning("请选择工单用料表进行操作")
      }
      if(this.selectedRows?.length === 0) {
        return this.$message.warning("请至少勾选一条单据进行操作")
      }
      const notAllow = this.selectedRows.find(item => !([STATUS_CODE.CREATE.lookupCode, STATUS_CODE.PLANNED_PRODUCT.lookupCode, STATUS_CODE.PUBLISHED.lookupCode, STATUS_CODE.DISPATCHED.lookupCode].includes(item.ccStatus)));
      if(notAllow) {
        return this.$message.warning("工单状态为‘新建’‘已排产’‘已发布’‘已派工’才能发起变更")
      }
      this.modalShow.materialChangeModal = true;
      this.$nextTick(() => {
        this.$refs.materialChangeModalRef.show(this.selectedRows);
      })
    },
    // 拆解
    onShowDismantleModal() {
      this.$refs.dismantleModalRef.show();
    },
    // 新增领料单
    onShowAddMaterialModal() {
      this.$refs.addMaterialModalRef.show();
    },
    // 撤销发布
    handleCancelPublish() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请至少勾选一条单据进行操作")
      }
      for(const item of this.selectedRows) {
        if(![STATUS_CODE.PUBLISHED.lookupCode].includes(item.status)) {
          return this.$message.warning("‘已派工状态的工单才能撤销派工，请重新选择工单")
        }
      }
      const idList = this.selectedRows.map(item => item.id);
      this.btnLoading = true;
      apiRevokePublishMesDiscreteJobsCcBill(idList).then(res => {
        if (res.code === 200) {
          this.$message.success('操作成功!')
          this.refreshList()
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.btnLoading = false;
      })
    },
    // 撤销派工
    handleCancelDispatch() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选一条单据进行操作")
      }
      for(const item of this.selectedRows) {
        if(![STATUS_CODE.DISPATCHED.lookupCode].includes(item.status)) {
          return this.$message.warning("‘已派工状态的工单才能撤销派工，请重新选择工单")
        }
      }
      const idList = this.selectedRows.map(item => item.id);
      this.btnLoading = true;
      apiRevokeDispatchMesDiscreteJobsCcBill(idList).then(res => {
        if (res.code === 200) {
          this.$message.success('操作成功!')
          this.refreshList()
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.btnLoading = false;
      })
    },
    // 派工
    handleDispatch() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选一条单据进行操作")
      }
      for(const item of this.selectedRows) {
        if(![STATUS_CODE.PUBLISHED.lookupCode].includes(item.status)) {
          return this.$message.warning("‘已发布状态的工单才能派工，请重新选择工单")
        }
      }
      const idList = this.selectedRows.map(item => item.id);
      this.btnLoading = true;
      apiDispatchMesDiscreteJobsCcBill(idList).then(res => {
        if (res.code === 200) {
          this.$message.success('操作成功!')
          this.refreshList()
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.btnLoading = false;
      })
    },
    // 拆单排产
    handleSplitOrder() {
      if(this.selectedRows.length !== 1) {
        return this.$message.warning("请勾选一条单据进行操作")
      }
      // 只有’新建‘’已排产‘状态才能拆分
      for(const item of this.selectedRows) {
        if(![STATUS_CODE.CREATE.lookupCode, STATUS_CODE.PLANNED_PRODUCT.lookupCode].includes(item.status)) {
          return this.$message.warning("只有新增，已排产状态才能拆分")
        }
      }
      const itemData = this.selectedRows[0];
      this.$refs.splitOrderModalRef.show(itemData);
    },
    // 发布
    handlePublish() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选单据进行操作")
      }
      // 只有已排产状态才能发布
      for(const item of this.selectedRows) {
        if(![STATUS_CODE.PLANNED_PRODUCT.lookupCode].includes(item.status)) {
          return this.$message.warning("只有已排产状态才能发布")
        }
      }
      this.btnLoading = true;
      apiPublishMesDiscreteJobsCcBill(this.selectedRows.map(item => item.id)).then(res => {
        if (res.code === 200) {
          this.$message.success('操作成功!')
          this.refreshList()
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.btnLoading = false;
      })
    },
    handleShowScheduleModal() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选单据进行操作")
      }
      let flag;
      for(const item of this.selectedRows) {
        if(!flag) {
          flag = item.workCode + item.desOrganizationCode;
        }else {
          if(flag !== item.workCode + item.desOrganizationCode) {
            return this.$message.warning("要选择同一车间同一加工组织的单据")
          }
        }
      }
      this.$refs.scheduleModalRef.show(this.selectedRows);
    },
    // 时间编辑
    onBatchEdit(field) {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选单据进行操作")
      }
      // 放开状态限制，都能操作
      let flag = '';
      for(const item of this.selectedRows) {
        // if(![STATUS_CODE.CREATE.lookupCode, STATUS_CODE.PLANNED_PRODUCT.lookupCode].includes(item.status)) {
        //   return this.$message.warning("只有新增，已排产状态才能操作")
        // }
        if(field === 'workCenterCode' || field === 'teamGroupCode') { // 工作中心，要校验车间是否一致
          if(!flag) {
            flag = item.workCode;
          }else {
            if(flag !== item.workCode) {
              return this.$message.warning("要选择同一车间的单据")
            }
          }
        }
      }
      this.$refs.BatchEditModalRef.show(this.selectedRows, field)
    },
    // 关闭
    handleClose() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选单据进行操作")
      }
      this.btnLoading = true;
      const idList = this.selectedRows.map(item => item.id);
      apiCloseMesDiscreteJobsCcLog(idList).then(response => {
        if (response.code === 200) {
          this.$message.success('操作成功!')
          this.refreshList()
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.btnLoading = false;
      })
    },
    // 取消
    handleCallOff () {
      if(!this.selectedRows?.length) {
        return this.$message.warning("请勾选单据进行操作")
      }
      const idList = this.selectedRows.map(item => item.id);
      this.$refs.cancelModalRef.show(idList)
    },
    /** 行选中 */
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 工单用料表编辑
    onMaterialEdit(field) {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选单据进行操作")
      }
      this.$refs.updateMaterialModalRef.show(this.selectedRows[0], field)
    },
    // $lookupMeaning(operationTypeList, record.operationType)
    onTableTypeChange(value) {
      this.selectedRows = [];
      this.selection = [TICKET_TABLE_TYPE.ticketInfo.value, TICKET_TABLE_TYPE.materialInfo.value].includes(this.activeTableType);
      if(this.activeTableType === TICKET_TABLE_TYPE.materialInfo.value) {
        this.dyCols = TICKET_MATERIAL_COL;
      }else if (this.activeTableType === TICKET_TABLE_TYPE.ticketInfo.value) {
        this.dyCols = TICKET_INFO_COL;
      }else if (this.activeTableType === TICKET_TABLE_TYPE.relateBill.value) {
        this.dyCols = TICKET_INFO_COL.filter(item => item.dataIndex !== 'operation')
      }
      this.refreshList();
    },
    onChangeState(list) {
      this.activeStateKey = list[0].id;
      this.refreshList();
    },
    onChangeStates(checked, record) {
      record.enable = Number(checked);
    },
    onSave(record) {
      const checkMap = {
        scheduledStartDate: '计划开始时间',
        scheduledCompletionDate: '计划完成时间',
        workCenterCode: '工作中心'
      }
      const errorList = [];
      for(const field in checkMap) {
        if(Array.isArray(record[field]) && !record[field].length) {
          errorList.push(checkMap[field]);
        }else if(!record[field]) {
          errorList.push(checkMap[field]);
        }
      }
      if(errorList?.length) {
        return this.$message.error(errorList.join(',') + '未填写');
      }
      const {
        id,
        remarks,
        workCenterCode,
        scheduledCompletionDate,
        scheduledStartDate
      } = record;
      const params = {
        id,
        remarks,
        workCenterCode,
        scheduledCompletionDate,
        scheduledStartDate
      }
      this.$set(record, 'loading', true);
      updateMesDiscreteJobsCc(params).then(response => {
        if (response.code === 200) {
          this.$message.success('操作成功')
          this.refreshList(true);
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.$set(record, 'loading', false);
      })
    },
    onEdit(record, editStatus) {
      if(![STATUS_CODE.CREATE.lookupCode, STATUS_CODE.PLANNED_PRODUCT.lookupCode].includes(record.status)) {
        return this.$message.warning("只有新增，已排产状态才能拆分")
      }
      if(editStatus) {
        record.tempRow = deepClone(record);
      }else {
        const tempRow = record.tempRow;
        for (const item in record) {
          record[item] = tempRow[item];
        }
        delete record.tempRow;
      }
      this.$set(record, 'editIs', editStatus);
    },
    // 新建
    onAddBill() {
      this.$refs.addModalRef.show()
    },
    onSearch(params) {
      if(!params.desOrganizationCode) {
        return this.$message.error('加工组织为空');
      }
      const newParams = { ...params };
      if(this.activeStateKey !== STATUS_CODE_TAB_V.ALL.lookupCode) {
        newParams.status = this.activeStateKey;
      }
      this.$refs.baseTable.searchParams = newParams;
      this.$refs.baseTable.getData(this.currentPageIs)
      this.currentPageIs = false
    },
    // 物料变更成功
    materialChangeSuccess() {
      this.modalShow.materialChangeModal = false;
      this.refreshList();
    },
    refreshList(currentPageIs) {
      this.$nextTick(() => {
        this.currentPageIs = !!currentPageIs
        this.$refs.searchFormRef.handleSearch()
      })
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen() {
      this.$refs.importExcelRef.show()
    },
    /** 导出按钮操作 */
    handleExport() {
      const params = this.$refs.baseTable.searchParams;
      this.$refs.download.openModal(params)
    },
    onToggleAdvanced() {
      setTimeout(() => {
        this.$refs.baseTable.initScrollY();
      }, 100)
    },
    // 关闭日志弹窗
    closeLogFun() {
      this.logLoading = false;
      this.logList = [];
    },
    // 操作日志弹窗
    handleLog(row) {
      this.logList = []
      this.logLoading = true
      this.$refs.operationLogModelRef.show();
      getMesDiscreteJobsCcLogApi({ id: row.id, type: 7 }).then(res => {
        if (res.code === 200) {
          if (res?.data?.length > 0) { this.logList = res.data }
        }
      }).finally(() => {
        this.logLoading = false
      })
    }
    // getStatesCode() {
    //   const lookupQueryParams = {
    //     lookupType: 'MES_MO_JOB_STATUS',
    //     current: 1,
    //     pageSize: 100
    //   }
    //   this.statesTabsList = [this.allTabItem];
    //   return this.getLookupListData(lookupQueryParams).then(response => {
    //     const list = response.rows || [];
    //     this.statesTabsList = list.map(item => {
    //       return {
    //         id: item.lookupCode,
    //         name: item.lookupValue
    //       }
    //     })
    //     this.statesTabsList.push(this.allTabItem);
    //   })
    // },
  }
}
</script>

<style scoped lang="less">
.link-btn {
  padding: 0 4px;
}
.text-3-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
/deep/.ant-input-number {
  width: 100%;
}
.select-width-130 {
  /deep/.ant-select {
    width: 120px;
  }
}
.error-border {
  border-color: #ff0000;
  /deep/.ant-select-selection {
    border-color: #ff0000;
  }
}
.error-text {
  font-size: 11px;
  color: #ff0000;
}
.action-icon{
  cursor: pointer;
  font-size: 14px;
  color: #0486fe;
}
</style>
